import { render, staticRenderFns } from "./LocationDetail.vue?vue&type=template&id=1ec0539b"
import script from "./LocationDetail.vue?vue&type=script&lang=js"
export * from "./LocationDetail.vue?vue&type=script&lang=js"
import style0 from "./LocationDetail.vue?vue&type=style&index=0&id=1ec0539b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports